exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".album_list_container[data-v-bb61cc46]{padding-top:100px;padding-bottom:100px}@media (max-width:767px){.album_list_container[data-v-bb61cc46]{padding-top:130px}.search-order-container[data-v-bb61cc46]{text-align:center}.search-order-container .order-block[data-v-bb61cc46]{float:none;justify-content:center}}", ""]);

// exports
